export default class Identity {
    id: string
}